module.exports = __webpack_public_path__ + "static/media/perk-solopreneur-1.c86d5649.jpg";